import { FC } from 'react';
import { replaceEmpty } from '@lhb/func';
import cs from 'classnames';
import styles from './index.module.less';
import { Typography } from 'antd';
import IconFont from '@/common/components/IconFont';

/**
 * 地址行
 * @description
 * @demo
 */
const AddressRow:FC<{ address: string, className?: string }> = ({ address, className }) => {

  /* state */

  /* hooks */

  /* methods */

  return (<div className={cs('fs-12 c-666 pointer', styles.addressRow, className)}>
    <IconFont iconHref='iconIC_dizhi' className={cs('mr-2 fs-10', styles.addressRow)}/>
    <Typography.Text ellipsis={{ tooltip: address }}>{replaceEmpty(address)}</Typography.Text>
  </div>);
};

export default AddressRow;
